import Vue from 'vue'
import Router from 'vue-router'
import Orders from '@/pages/Orders'
import ordersBeta from '@/pages/ordersBeta'
import Home from '@/pages/Home'
import Secret from '@/pages/Secret'
import SelectedOrder from '@/pages/SelectedOrder'
import signIn from '@/pages/signIn'
import AddWorkers from '@/pages/AddWorkers'
import Meheron from '@/pages/Meheron'
import CreateOrderBeta from '@/pages/CreateOrderBeta'
import newOrderbeta from '@/pages/newOrderbeta'
import SelectedOrderBeta from '@/pages/SelectedOrderBeta'
import Inventory from '@/pages/Inventory'
import Suppliers from '@/pages/Suppliers'
import Settings from '@/pages/Settings'
import Media from '@/pages/Media'
import Trash from '@/pages/Trash'
import cheques from '@/pages/cheques'
import chequesBeta from '@/pages/chequesBeta'
import reports from '@/pages/reports'

import expenses from '@/pages/expenses'
import checkout from '@/pages/checkout'
import printOrder from '@/pages/printOrder'


import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";
Vue.use(Router)
const router =  new Router({
  mode: "history",
  base: process.env.Base_URL,

  routes: [
    {
      path: '/',
      name: 'signIn',
      component: signIn,
      meta: {
      hideNavbar: true,
      }
      
    },
    { path: '/catalog/:slug', name: 'CatalogDynamic', component: () => import('@/pages/CatalogPage.vue') },
    {
      path: '/Home',
      name: 'Home',
      component: Home,
      //meta: { requiresAuth: true},
    },
    {
      path: '/Orders',
      name: 'Orders',
      component: Orders,
      //meta: { requiresAuth: true},
    },
    {
      path: '/OrdersBeta',
      name: 'ordersBeta',
      component: ordersBeta,
      //meta: { requiresAuth: true},
    },
    {
      path: '/Secret',
      name: 'Secret',
      component: Secret,
      //meta: { requiresAuth: true},
      meta: { adminOnly: true }
    },
    {
      path: '/SelectedOrder' ,
      name: 'SelectedOrder',
      component: SelectedOrder,
      //meta: { requiresAuth: true},
    },
    {
      path: '/AddWorkers',
      name: 'AddWorkers',
      component: AddWorkers,
      //meta: { requiresAuth: true},
      meta: { adminOnly: true }
    },
    {
      path: '/Meheron',
      name: 'Meheron',
      component: Meheron,
      //meta: { requiresAuth: true},
      meta: { adminOnly: true }
    },
    ,
    {
      path: '/CreateOrderBeta',
      name: 'CreateOrderBeta',
      component: CreateOrderBeta,
      props: true

      //meta: { requiresAuth: true},
    },
    
    {
      path: '/newOrderbeta',
      name: 'newOrderbeta',
      component: newOrderbeta,
      props: true

      //meta: { requiresAuth: true},
    },
    {
      path: '/SelectedOrderBeta/:id' ,
      name: 'SelectedOrderBeta',
      component: SelectedOrderBeta,
      //meta: { requiresAuth: true},
    },
    {
      path: '/Inventory/' ,
      name: 'Inventory',
      component: Inventory,
      //meta: { requiresAuth: true},
      
    },
    {
      path: '/Suppliers' ,
      name: 'Suppliers',
      component: Suppliers,
      //meta: { requiresAuth: true},
      meta: { adminOnly: true }
    },
    {
      path: '/Settings' ,
      name: 'Settings',
      component: Settings,
      //meta: { requiresAuth: true},
    },
    {
      path: '/Media' ,
      name: 'Media',
      component: Media,
    },
    {
      path: '/Trash' ,
      name: 'Trash',
      component: Trash,
    },
    {
      path: '/cheques' ,
      name: 'cheques',
      component: cheques,
      meta: { adminOnly: true }
    },
    {
      path: '/expenses' ,
      name: 'expenses',
      component: expenses,
      meta: { adminOnly: true }
    },
    {
      path: '/checkout' ,
      name: 'checkout',
      component: checkout,
    },
    {
      path: '/reports' ,
      name: 'reports',
      component: reports,
      meta: { adminOnly: true }
    },    {
      path: '/Suppliers/:id',
      name: 'SupplierLedger',
      component: () => import('@/pages/SupplierLedger.vue'),
      meta: { adminOnly: true }
    }
    
  ]
});
// router.beforeEach((to, from, next) => {
//   const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
//   const currentUser = firebase.auth().currentUser

//   if (requiresAuth && !currentUser) {
//     next('/')
//   } else if (requiresAuth && currentUser) {
//     next()
//   } else {
//     next()
//   }
// });
router.beforeEach((to, from, next) => {

    const user =
        JSON.parse(
            localStorage.getItem("User")
        )

    // صفحات مسموحة بدون تسجيل
    const publicPages = [

        '/'

    ]

    // هل الصفحة تحتاج login؟
    const authRequired =
        !publicPages.includes(to.path)

    // إذا مش مسجل دخول
    if(authRequired && !user){

        return next('/')

    }

    // صفحات الأدمن فقط
    if(
        to.meta.adminOnly
        &&
        user.Type !== 'Admin'
    ){

        alert("אין לך גישה לדף הזה")

        return next('/Home')

    }

    next()

})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js